var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00039 0.799805C6.01217 0.799805 4.40039 2.41158 4.40039 4.3998V7.1998H4.00039C3.11674 7.1998 2.40039 7.91615 2.40039 8.7998V13.5998C2.40039 14.4835 3.11673 15.1998 4.00039 15.1998H12.0004C12.884 15.1998 13.6004 14.4835 13.6004 13.5998V8.7998C13.6004 7.91615 12.884 7.1998 12.0004 7.1998H11.6004V4.3998C11.6004 2.41158 9.98862 0.799805 8.00039 0.799805ZM10.4004 7.1998V4.3998C10.4004 3.07432 9.32587 1.9998 8.00039 1.9998C6.67491 1.9998 5.60039 3.07432 5.60039 4.3998V7.1998H10.4004Z",
    fill: "#ABA9B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.1eb34b1e400a328227a5bbe4a3d08ce4.svg";
export { ForwardRef as ReactComponent };